module.exports = __webpack_public_path__ + "static/fasanmade-495b9175cb132b1ebfb90ac70eb2b79d.png";